module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-two"
  }, [_c('p', [_vm._v("Component Two (should be blue)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7dce524!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComponentTwo.vue
// module id = 318
// module chunks = 2